import { scheduleConstants } from '../../constants';

const initialSchedulesState = {
  schedulesList: [] as any[]
};

export function schedules(state = initialSchedulesState, action: any) {
  switch (action.type) {
    case scheduleConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case scheduleConstants.GETALL_SUCCESS:
      return {
        ...state,
        schedulesList: action.payload
      };
    case scheduleConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    case scheduleConstants.CREATE_SUCCESS:
      return {
        ...state,
        schedulesList: [...state.schedulesList, ...action.payload]
      };
    case scheduleConstants.DELETE_SUCCESS:
      return {
        ...state,
        schedulesList: state.schedulesList.filter(schedule => schedule.classId !== action.payload)
      };
    case scheduleConstants.UPDATE_SUCCESS:
      const updatedClassId = action.payload?.[0]?.classId;
      const remaining = updatedClassId
        ? state.schedulesList.filter(schedule => schedule.classId !== updatedClassId)
        : state.schedulesList;
      return {
        ...state,
        schedulesList: [...remaining, ...action.payload],
      };
    default:
      return state;
  }
}
